export default "__VITE_ASSET__auCUDFM9__"